import {Box} from "@mui/material";

import {retrieveServiceTypeIcon} from "../../helpers/ServiceTypeUtils";

export default function SeatCountMetric({bookedSeats, totalSeats}) {
    return (
        <Box flex={1} display="flex" justifyContent="flex-end">
            <Box display="flex" alignItems="flex-start" gap="0.3rem">
                <Box component="img" src={retrieveServiceTypeIcon([process.env.REACT_APP_SCHEDULE_METRIC_SERVICE_TYPE])} sx={{height: '1rem'}}/>
                {bookedSeats}/{totalSeats}
            </Box>
        </Box>
    );
}